import { Record } from "immutable"

export const schema = {
  id: undefined,
  name: "",
  backgroundColor: "#5a06b7",
  color: "#ffffff",
}

export default Record(schema)



// WEBPACK FOOTER //
// ./src/models/brand.model.js